import { useState } from 'react'
import styles from './styles.module.scss'
import Transaction from '../Transaction'
import dayjs from 'dayjs'

interface IProps {
  transaction: any
}

const Group = ({ transaction }: IProps) => {
  const [showDetails, setShowDetails] = useState(false)

  const formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  })

  // Extract payment method totals if they exist
  const paymentMethodTotals = transaction[1].paymentMethodTotals || {}

  // Filter out payment methods with zero transactions
  const paymentMethods = Object.entries(paymentMethodTotals)
    .filter(([_, amount]) => (amount as any) > 0)
    .sort((a, b) => (b[1] as number) - (a[1] as number)) // Sort by amount in descending order

  return (
    <div className={styles.group}>
      <div className={styles.tab} onClick={() => setShowDetails(!showDetails)}>
        <span className={styles.date}>{dayjs(transaction[0]).format('dddd, DD.MM.YYYY')}</span>
        <span className={styles.amount}>{formatter.format(transaction[1].combined)}</span>
      </div>
      {showDetails && (
        <>
          {paymentMethods.length > 0 && (
            <div className={styles.paymentMethods}>
              {paymentMethods.map(([method, amount], index) => (
                <div key={index} className={styles.paymentMethod}>
                  <span className={styles.methodName}>{method}:</span>
                  <span className={styles.methodAmount}>{formatter.format(amount as number)}</span>
                </div>
              ))}
            </div>
          )}
          <div className={styles.inner}>
            {transaction[1].transactions.map((transaction: any, i: number) => {
              return <Transaction transaction={transaction} key={i} />
            })}
          </div>
        </>
      )}
    </div>
  )
}

export default Group
